import React from "react";

const VideoPlayer = ({ path, height }) => {
  const isYouTubeUrl =
    path.includes("youtube.com") || path.includes("youtu.be");

  if (isYouTubeUrl) {
    const videoId = path.split("?v=")[1] || path.split("/").slice(-1)[0];
    const embedUrl = `https://www.youtube.com/embed/${videoId}`;

    return (
      <div
        style={{ width: "100%", maxWidth: "100%", overflow: "hidden", height }}
      >
        <iframe
          title="YouTube video player"
          width="100%"
          height="100%"
          src={embedUrl}
          frameBorder="0"
          allowFullScreen
          style={{ display: "block" }}
        />
      </div>
    );
  } else {
    return (
      <div
        style={{ width: "100%", maxWidth: "100%", overflow: "hidden", height }}
      >
        <video controls width="100%" height="100%" style={{ display: "block" }}>
          <source src={path} type="video/mp4" />
          No data.
        </video>
      </div>
    );
  }
};

export default VideoPlayer;
